import { useNavigate } from "react-router";
import { RecapStatus } from "../../../Services/DataService/Model/RecapEntry";
import { GetToday } from "../../../Services/Utilities";
import { DailyEntryViewModel } from "../../../ViewModel";



export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6
}

const singleLetterAbbreviation = (day: DayOfWeek): string => {
    const abbreviations: { [key in DayOfWeek]: string } = {
        [DayOfWeek.Sunday]: 'S',
        [DayOfWeek.Monday]: 'M',
        [DayOfWeek.Tuesday]: 'T',
        [DayOfWeek.Wednesday]: 'W',
        [DayOfWeek.Thursday]: 'T',
        [DayOfWeek.Friday]: 'F',
        [DayOfWeek.Saturday]: 'S',
    };
    return abbreviations[day];
};

// const twoLetterAbbreviation = (day: DayOfWeek): string => {
//     const abbreviations: { [key in DayOfWeek]: string } = {
//         [DayOfWeek.Sunday]: 'Su',
//         [DayOfWeek.Monday]: 'Mo',
//         [DayOfWeek.Tuesday]: 'Tu',
//         [DayOfWeek.Wednesday]: 'We',
//         [DayOfWeek.Thursday]: 'Th',
//         [DayOfWeek.Friday]: 'Fr',
//         [DayOfWeek.Saturday]: 'Sa',
//     };
//     return abbreviations[day];
// };

// const threeLetterAbbreviation = (day: DayOfWeek): string => {
//     const abbreviations: { [key in DayOfWeek]: string } = {
//         [DayOfWeek.Sunday]: 'Sun',
//         [DayOfWeek.Monday]: 'Mon',
//         [DayOfWeek.Tuesday]: 'Tue',
//         [DayOfWeek.Wednesday]: 'Wed',
//         [DayOfWeek.Thursday]: 'Thu',
//         [DayOfWeek.Friday]: 'Fri',
//         [DayOfWeek.Saturday]: 'Sat',
//     };
//     return abbreviations[day];
// };

export interface IDayStatus {
    date: Date;
    status: string;
    scoreColor?: string;
}
const defaultWeek: IDayStatus[] = [
    { date: new Date(2024, 7, 11), status: RecapStatus.Complete },
    { date: new Date(2024, 7, 12), status: RecapStatus.Inprogress },
    { date: new Date(2024, 7, 13), status: RecapStatus.NotStarted },
    { date: new Date(2024, 7, 14), status: RecapStatus.Complete },
    { date: new Date(2024, 7, 15), status: RecapStatus.Complete },
    { date: new Date(2024, 7, 16), status: RecapStatus.NotStarted },
    { date: new Date(2024, 7, 17), status: RecapStatus.Complete },
]

export function WeeklyProgress({ statuses, showComplete }: { statuses?: IDayStatus[], showComplete?: boolean }) {

    const navigate = useNavigate();
    const ourStatuses = statuses ?? defaultWeek;

    if (showComplete) {
        for (let status of ourStatuses) {
            status.scoreColor = undefined;
            status.status = RecapStatus.Complete;
        }
    }

    const onDayClick = async (status: IDayStatus) => {
        if (status.status === RecapStatus.NotStarted || status.status === RecapStatus.NotReady)
            return;
        navigate(await DailyEntryViewModel.GetRoute(status.date));
    }

    return (
        <div className=" flex flex-row justify-content-between gap-50 align-items-center">
            {
                ourStatuses.map((dayStatus) => {
                    return (
                        <div
                            key={`${dayStatus.date.toDateString()}-${dayStatus.status}`}
                            onClick={() => onDayClick && onDayClick(dayStatus)}
                        >
                            <DayStatusCircle
                                status={dayStatus.status}
                                date={dayStatus.date}
                                scoreColor={dayStatus.scoreColor}
                            />
                        </div>
                    );
                }
                )
            }
        </div>
    );
}

interface IDayStatusCircleProps {
    status: string | "Complete",
    date: Date,
    scoreColor?: string
};
export function DayStatusCircle({ status, date, scoreColor }: IDayStatusCircleProps) {

    const day = date.getDay() as DayOfWeek
    const statusOrColorStr = scoreColor ?? status;
    const statusStr =
        date
            && date.getTime() === GetToday().getTime()
            && status !== RecapStatus.Complete
            ? "today" : statusOrColorStr;
    const statusClass = `gl-day-status-circle-${statusStr}`;
    return (
        <>
            {
                statusStr !== RecapStatus.Inprogress
                    ?
                    <div className={`gl-day-status-circle ${statusClass} gl-text-entry-typography flex justify-content-center align-items-center`}
                    >{singleLetterAbbreviation(day)}</div>
                    :
                    <div className="relative gl-day-status-circle-incomplete flex align-items-center justify-content-center">
                        <div className="flex flex-column align-items-center justify-content-center gl-day-status-circle gl-day-status-container ">
                            <div className={'gl-day-status-circle-top'}></div>
                            <div className={'gl-day-status-circle-bottom '}></div>
                        </div>
                        <p className="gl-day-status-circle-incomplete-text absolute">{singleLetterAbbreviation(day)}</p>
                    </div>
            }
        </>
    );
}